// extracted by mini-css-extract-plugin
module.exports = {"TitleBox":"Title_TitleBox__3Li6A"};